module.exports = __webpack_public_path__ + "static/media/sort-up.adfde80c.svg";